import { createContext } from 'react';
import type { TemplateListItemRes } from 'types';

export interface HeliosTemplateChildrenContextValue {
  data: Map<string, TemplateListItemRes[]>;
  isLoading: boolean;
}

export const HeliosTemplateChildrenContext = createContext<HeliosTemplateChildrenContextValue | undefined>(undefined);
